import React, { useRef, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DialogTitle, DialogContent, Dialog } from '@mui/material';
import { X } from 'lucide-react';

const TextWithReadMore = ({ text, dialogTitle }) => {
    const classes = useStyles();
    const descriptionRef = useRef(null);

    const [showButton, setShowButton] = useState(false);
    const [openReadMoreDialog, setOpenReadMoreDialog] = useState(false);

    useEffect(() => {
        const element = descriptionRef.current;
        if (element) {
            // Check if content overflows the 5-line height
            const isOverflowing =
                element.scrollHeight > element.offsetHeight;
            setShowButton(isOverflowing);
        }
    }, [text]);

    return (
        <>
            <div>
                <p ref={descriptionRef} className={classes.paragraph}>{text}</p>
                {showButton && (
                    <button onClick={() => setOpenReadMoreDialog(true)} className={classes.readMoreButton}>
                        Read More
                    </button>
                )}
            </div>

            <Dialog className={classes.dialog}
                open={openReadMoreDialog}
                aria-labelledby="draggable-dialog-title"
                onClose={() => setOpenReadMoreDialog(false)}
                classes={{ paper: classes.dialogPaper }}
            >
                <div className={classes.dialog__head}>
                    <DialogTitle className={classes.dialog__title} id="draggable-dialog-title">
                        {dialogTitle ? dialogTitle : "Read More"}
                    </DialogTitle>
                    <button onClick={() => setOpenReadMoreDialog(false)} className={classes.dialog__closeButton}>
                        <X size={19} />
                    </button>
                </div>
                <DialogContent className={classes.dialog__contentContainer}>
                    <div className={classes.dialog__content}>
                        <p className={classes.content__paragraph}>{text}</p>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default TextWithReadMore;

const useStyles = makeStyles((theme) => ({
    paragraph: {
        fontFamily: "Lato, sans-serif",
        fontSize: "16px",
        color: "inherit",
        margin: "0px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: "3",
        WebkitBoxOrient: "vertical",
        marginBottom: "8px",

        [theme.breakpoints.down('sm')]: {
            WebkitLineClamp: "5",
        },
    },

    readMoreButton: {
        padding: "0",
        boxSizing: "border-box",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "inherit",
        backgroundColor: "transparent",

        transition: "all 0.2s ease-in-out",
        whiteSpace: "nowrap",

        userSelect: "none",

        "&:hover": {
            cursor: "pointer",
            textDecoration: "underline",
            textUnderlineOffset: "4px",
        },

        "&:focus-visible": {
            textDecoration: "underline",
            textUnderlineOffset: "4px",
        },
    },

    dialog: {
        margin: "auto"
    },

    dialogPaper: {
        width: '640px !important',
        height: 'auto',
        borderRadius: '6px !important',
    },

    dialog__head: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',

        padding: '16px 16px 0px 16px !important',
        marginBottom: '16px !important',
    },

    dialog__title: {
        fontSize: '24px !important',
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'normal',
        lineHeight: "29px !important",

        padding: '0px !important',
    },

    dialog__closeButton: {
        backgroundColor: '#F5F5F5',
        border: 'none',
        cursor: 'pointer',

        padding: '3px !important',
        height: '25px !important',

        borderRadius: '3px',

        transition: 'all 0.2s',

        '&:hover': {
            backgroundColor: '#D84949',
            color: '#F5F5F5',
        },

        '&:focus-visible': {
            outline: '#C3996B auto 1px',
        },
    },

    dialog__contentContainer: {
        padding: '0px 16px !important',
        marginBottom: "16px",

        // remove scrollbar
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none',
    },

    dialog__content: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',

        margin: '0px !important',
    },

    content__paragraph: {
        fontFamily: "Lato, sans-serif",
        fontSize: "16px",
        color: "#0C0E29",
        margin: "0px",
    }
}));